import apiRequest from './client';

// GET /api/tickets/prized-numbers/ (portail company, Rapports > Paris gagnants).
// tirage = code catalogue (requis), date = YYYY-MM-DD, filter = 'All'|'Group'|'Supervisor'|'Bank'
// (meme convention que Sales Monitoring/Winning Tickets), scope = id du group/superviseur/bank
// (omis pour 'All'). Renvoie { has_result, sections:[{product_abbr,product_name,rows:[{numero,points,vendu,gagne,match}]}], ventes_brutes, total_gains }.
export const fetchPrizedNumbers = ({ tirage, date, filter = 'All', scope }) => {
  const params = new URLSearchParams({ tirage, date, filter });
  if (scope) params.set('scope', scope);
  return apiRequest(`/tickets/prized-numbers/?${params.toString()}`);
};
